module.exports = __webpack_public_path__ + "static/media/Bunny-roadmap.942469de.jpg";